import { shape, string } from "prop-types";

import PointerIcon from "web/assets/icons/pointer.svg";

import classify from "web/classify";

import defaultClasses from "./placeInfo.scss";

const PlaceInfo = ({ address, name, classes, cities }) => {
  return address || name || cities ? (
    <div className={classes.root}>
      <PointerIcon className={classes.icon} />
      {address && <span>{address}</span>}
      {cities && <span className={classes.cities}>{cities}</span>}
      {name && (
        <div data-t1="code_realization_place" data-t2={name}>
          {name}
        </div>
      )}
    </div>
  ) : null;
};

PlaceInfo.propTypes = {
  address: string,
  name: string,
  cities: string,
  classes: shape({
    root: string,
    shape: string,
    icon: string,
  }),
};

PlaceInfo.defaultProps = {
  classes: {},
  name: "",
  address: "",
  cities: "",
};

export default classify(defaultClasses)(PlaceInfo);
